import { PPFormFieldProps } from '../FormDropdownPP/FormDropdownPP';
import FormField from '../FormField/FormField';
import { useFormContext } from 'react-hook-form';
import FormNumberedCheckboxesGroup from '../FormNumberedCheckboxesGroup/FormNumberedCheckboxesGroup';
import React, { useEffect, useMemo, useState } from 'react';

export const FormNumberedCheckboxesWithOther = (props: PPFormFieldProps) => {
  const { name, subfields, otherOptionValue, isRequired } = props;
  const { watch, setValue, clearErrors, trigger } = useFormContext();
  const [shouldValidateOther, setShouldValidateOther] =
    useState<boolean>(false);
  const otherFieldProps = subfields?.find(
    subfield => subfield.name === `${name}Other`,
  ) as PPFormFieldProps;

  const selectedValue = watch(name);

  const isOtherSelected = useMemo(() => {
    if (!otherOptionValue) return false;

    if (selectedValue === otherOptionValue) return true;

    if (Array.isArray(selectedValue)) {
      if (selectedValue.includes(otherOptionValue)) return true;

      if (
        typeof otherOptionValue === 'string' &&
        otherOptionValue.includes('*|*')
      ) {
        const otherValues = otherOptionValue.split('*|*').map(v => v.trim());
        return selectedValue.some((val: string) => otherValues.includes(val));
      }
    }

    return false;
  }, [selectedValue]);

  useEffect(() => {
    const validateOther = Boolean(isRequired && isOtherSelected);
    setShouldValidateOther(validateOther);
  }, [isOtherSelected, isRequired]);

  useEffect(() => {
    if (!shouldValidateOther) {
      clearErrors(`${name}Other`);
      return;
    }
    trigger(`${name}Other`);
  }, [shouldValidateOther, name, setValue, clearErrors, trigger]);

  otherFieldProps.isRequired = shouldValidateOther;

  return (
    <>
      <FormNumberedCheckboxesGroup {...props} key={props.key} />
      <FormField {...otherFieldProps} key={otherFieldProps.key} />
    </>
  );
};
export default FormNumberedCheckboxesWithOther;
